try {
    $(document).ready(function () {
        var jsMovedDsp = $('.js-moved-dsp');
        var paginationHandle = $('.products-list__bottom-actions');
        var windowWidth = $(document).width();

        if (jsMovedDsp.length > 0 && paginationHandle.length > 0) {
            if (windowWidth < 1200) paginationHandle.append(jsMovedDsp);
        }
    });
} catch (error) {
    console.log(error);
}

try {
    var jsMovedDsp = $('.js-moved-dsp');
    var listActionHandle = $('#js-product-list-top');
    var paginationHandle = $('.products-list__bottom-actions');

    $(window).resize(function () {
        var windowWidth = $(document).width();
        if (jsMovedDsp.length > 0 && listActionHandle.length > 0 && paginationHandle.length > 0) {
            if (windowWidth < 1200) paginationHandle.append(jsMovedDsp);
            if (windowWidth >= 1200) jsMovedDsp.insertBefore(listActionHandle);
        }
    });

} catch (error) {
    console.log(error);
}